import { ArrowRight } from "lucide-react";
import { scrollToId } from "../../hooks/useScrollTo";
import Typography from "../ui/Typography";

const HeroSection = () => {
  return (
    <>
      <section className="mb-20">
        {/* Animated Heading */}
        <div className="overflow-hidden">
          <Typography.Heading
            className="mb-8 animate-fade-up"
            style={{
              animationDelay: "0.2s",
              animationFillMode: "both",
            }}
          >
            Technology that
            <br />
            <span
              className="inline-block animate-slide-in-right"
              style={{ animationDelay: "0.6s", animationFillMode: "both" }}
            >
              solves local problems
            </span>
          </Typography.Heading>
        </div>

        {/* Animated Subheading */}
        <Typography.Subheading
          className="max-w-2xl mb-12 text-gray-300 animate-fade-up"
          style={{
            animationDelay: "0.8s",
            animationFillMode: "both",
          }}
        >
          Empowering communities through AI, machine learning, and intelligent
          software solutions.
        </Typography.Subheading>

        {/* Animated Buttons */}
        <div
          className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4 animate-fade-up"
          style={{
            animationDelay: "1.2s",
            animationFillMode: "both",
          }}
        >
          <button
            type="button"
            onClick={() => scrollToId("solutions")}
            className="group bg-white text-black px-6 py-3 rounded-md text-btn hover:bg-gray-200 transition-all duration-300 transform hover:scale-105 hover:shadow-lg flex items-center justify-center gap-2 focus-visible:ring-2 focus-visible:ring-indigo-500/50 focus-visible:outline-none"
          >
            Explore Solutions
            <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
          </button>
          <button
            type="button"
            onClick={() => scrollToId("schedule")}
            className="group border border-gray-700 cursor-pointer text-white px-6 py-3 rounded-md text-btn hover:border-gray-500 hover:bg-white/5 transition-all duration-300 transform hover:scale-105 backdrop-blur-sm focus-visible:ring-2 focus-visible:ring-indigo-500/50 focus-visible:outline-none"
          >
            Schedule Consultation
          </button>
        </div>
      </section>
    </>
  );
};

export default HeroSection;
